import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { AnonymousSignService } from 'src/app/core/services/anonymous-sign.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-approve-action-dialog',
  templateUrl: './approve-action-dialog.component.html',
  styleUrls: ['./approve-action-dialog.component.scss']
})
export class ApproveActionDialogComponent implements OnInit {

  actionForm: FormGroup
  title: string
  placeholder: string
  isRequired: boolean
  isSetUpSignFlow: boolean
  private hashKey: string;
  private tenantId: string;
  contractIdAndContractEnterpriseIdEncode: string = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ApproveActionDialogComponent>,
    private anonymousSignService: AnonymousSignService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private message: Message,
    private fb: FormBuilder,
    private router: Router,
  ) {
    if(data.typeDialog == 'APPROVE'){
      this.title = 'approved.enter_approve_content'
      this.placeholder = 'approved.enter_approve_content'
      this.actionForm = this.fb.group({content: new FormControl('')})
      this.isSetUpSignFlow = data.isSetUpSignFlow ? data.isSetUpSignFlow : false
    }
    if(data.typeDialog == 'REJECT'){
      this.title = 'approved.reject_reason'
      this.placeholder = 'approved.enter_reason_reject'
      this.isRequired = true
      this.actionForm = this.fb.group({content: new FormControl('', Validators.required)})
      this.isSetUpSignFlow = data.isSetUpSignFlow ? data.isSetUpSignFlow : false
    }
  }

  ngOnInit() {
    this.hashKey = this.data.hashKey
    this.tenantId = this.data.tenantId
    this.contractIdAndContractEnterpriseIdEncode = this.data.contractIdAndContractEnterpriseIdEncode
  }

  onCancel(){
    this.dialogRef.close();
  }

  onSave(){
    if(this.actionForm.invalid){
      this.actionForm.markAllAsTouched();
      return
    }
    let value = {
      reason: this.actionForm.controls['content'].value,
      hashKey: this.data.hashKey,
      tenantId: this.data.tenantId
    }
    if(this.data.typeDialog == 'APPROVE'){
      this.onApproveContract(value)
    }
    if(this.data.typeDialog == 'REJECT'){
      this.onRejectApproveContract(value)
    }
    console.log(value);

  }

  onApproveContract(value){
    this.anonymousSignService.userApproveContract(value).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.message);
        if (res.code === '0x00115') {
          this.router.navigate(['/error'],
          {queryParams: {errorCode:'Approved', errorMessage: res.message}}
          );
        }
        return;
      } else {
        this.dialogRef.close(true);
        if(this.isSetUpSignFlow){
          this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}/detail`]);
        } else {
          this.router.navigate(['/approval/success']);
        }
        this.toastr.success(this.message.getMessage('approved.approval_success'));
        return;
      }
    });
  }

  onRejectApproveContract(value){
    this.anonymousSignService.userRefuseApproveContract(value).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.message);
        if (res.code === '0x00115') {
          this.router.navigate(['/error'],
          {queryParams: {errorCode:'Approved', errorMessage: res.message}}
          );
        }
        return;
      } else {
        this.dialogRef.close(true);
        this.toastr.success(this.message.getMessage('approved.reject_approval_success'));
        setTimeout(() => {
          if(this.isSetUpSignFlow){
            window.location.reload();
          } else {
            this.router.navigate(['/approval/reject']);
          }
        }, 3000);
        return;
      }
    });
  }

  onNoClick() {
    this.dialogRef.close();
  }

  onFocusReason(){
    this.actionForm.get('content').patchValue(this.actionForm.value['content'].trim())
  }

}
